module.exports = __webpack_public_path__ + "static/resolve-d444d16c3ab959a45edc4d88b3b7f401.png";